var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77502 17.5248C9.62502 17.3414 9.54586 17.1331 9.53752 16.8998C9.52919 16.6664 9.60836 16.4664 9.77502 16.2998L14.1 11.9748L9.75002 7.62476C9.60002 7.47476 9.52919 7.2706 9.53752 7.01226C9.54586 6.75393 9.62502 6.54976 9.77502 6.39976C9.95836 6.21643 10.1625 6.12893 10.3875 6.13726C10.6125 6.1456 10.8084 6.2331 10.975 6.39976L15.95 11.3748C16.0334 11.4748 16.0959 11.5706 16.1375 11.6623C16.1792 11.7539 16.2 11.8581 16.2 11.9748C16.2 12.0914 16.1792 12.1956 16.1375 12.2873C16.0959 12.3789 16.0334 12.4748 15.95 12.5748L11 17.5248C10.8334 17.6914 10.6334 17.7706 10.4 17.7623C10.1667 17.7539 9.95836 17.6748 9.77502 17.5248V17.5248Z",
    fill: "#AAAAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextDisabled);
export default __webpack_public_path__ + "static/media/nextDisabled.8aa2f20b.svg";
export { ForwardRef as ReactComponent };